require('../../../modules/es.array.concat');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').concat;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/concat.js
// module id = 971
// module chunks = 0